import { useState } from "react";

const serviceOfferings = [
  "Bookkeeping", "Payroll", "Tax Preparation", "Financial Reporting", "Consulting"
];
const reportingFrequencies = [
  "Weekly", "Monthly", "Quarterly", "Annually"
];
const executionTools = [
  "QuickBooks", "Xero", "Excel", "Other"
];
const dataHostingOptions = [
  "Cloud", "On-premises", "Hybrid"
];
const deliveryModels = [
  "Remote", "Onsite", "Hybrid"
];

const steps = [
  {
    title: "Client Project Contact",
    description: "Who should we contact about this project?",
    key: "contactName",
    render: (value, onChange, enabled) => (
      <input type="text" placeholder="Contact Name" className="input" value={value} onChange={onChange} disabled={!enabled} />
    ),
    validate: v => !!v,
  },
  {
    title: "Project",
    description: "Select the project type.",
    key: "projectType",
    render: (value, onChange, enabled) => (
      <select className="input" value={value} onChange={onChange} disabled={!enabled}>
        <option value="">Select...</option>
        {serviceOfferings.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
    ),
    validate: v => !!v,
  },
  {
    title: "Project Deliverable Reporting Frequency",
    description: "How often do you need deliverables?",
    key: "reportingFrequency",
    render: (value, onChange, enabled) => (
      <select className="input" value={value} onChange={onChange} disabled={!enabled}>
        <option value="">Select...</option>
        {reportingFrequencies.map((f) => <option key={f} value={f}>{f}</option>)}
      </select>
    ),
    validate: v => !!v,
  },
  {
    title: "Proposed Project Start Date",
    description: "When would you like to start?",
    key: "startDate",
    render: (value, onChange, enabled) => (
      <input type="date" className="input" value={value} onChange={onChange} disabled={!enabled} />
    ),
    validate: v => !!v,
  },
  {
    title: "Project Execution Tools",
    description: "Select tools for project execution.",
    key: "executionTool",
    render: (value, onChange, enabled) => (
      <select className="input" value={value} onChange={onChange} disabled={!enabled}>
        <option value="">Select...</option>
        {executionTools.map((t) => <option key={t} value={t}>{t}</option>)}
      </select>
    ),
    validate: v => !!v,
  },
  {
    title: "Data Hosting",
    description: "Where will your data be hosted?",
    key: "dataHosting",
    render: (value, onChange, enabled) => (
      <select className="input" value={value} onChange={onChange} disabled={!enabled}>
        <option value="">Select...</option>
        {dataHostingOptions.map((d) => <option key={d} value={d}>{d}</option>)}
      </select>
    ),
    validate: v => !!v,
  },
  {
    title: "Service Delivery Model",
    description: "Choose your preferred delivery model.",
    key: "deliveryModel",
    render: (value, onChange, enabled) => (
      <select className="input" value={value} onChange={onChange} disabled={!enabled}>
        <option value="">Select...</option>
        {deliveryModels.map((m) => <option key={m} value={m}>{m}</option>)}
      </select>
    ),
    validate: v => !!v,
  },
  {
    title: "Offshore Resources Allowed?",
    description: "Are offshore resources allowed?",
    key: "offshoreAllowed",
    render: (value, onChange, enabled) => (
      <div>
        <label><input type="radio" name="offshoreAllowed" value="yes" checked={value === "yes"} onChange={onChange} disabled={!enabled} /> Yes</label>
        <label style={{ marginLeft: 16 }}><input type="radio" name="offshoreAllowed" value="no" checked={value === "no"} onChange={onChange} disabled={!enabled} /> No</label>
      </div>
    ),
    validate: v => v === "yes" || v === "no",
  },
  {
    title: "Preferred Contact",
    description: "How should we contact you?",
    key: "preferredContact",
    render: (value, onChange, enabled) => (
      <div>
        <label><input type="radio" name="preferredContact" value="email" checked={value === "email"} onChange={onChange} disabled={!enabled} /> Email</label>
        <label style={{ marginLeft: 16 }}><input type="radio" name="preferredContact" value="telephone" checked={value === "telephone"} onChange={onChange} disabled={!enabled} /> Telephone</label>
      </div>
    ),
    validate: v => v === "email" || v === "telephone",
  },
  {
    title: "Schedule a Meeting",
    description: "Schedule a meeting with one of our partners now.",
    key: "scheduleMeeting",
    render: (value, onChange, enabled) => (
      <button className="btn primary" onClick={() => enabled && alert("Launch scheduling tool") } disabled={!enabled}>Launch Scheduling Tool</button>
    ),
    validate: v => true,
  },
];

export default function IntakeStart() {
  const [values, setValues] = useState({
    contactName: "",
    projectType: "",
    reportingFrequency: "",
    startDate: "",
    executionTool: "",
    dataHosting: "",
    deliveryModel: "",
    offshoreAllowed: "",
    preferredContact: "",
    scheduleMeeting: false,
  });

  // Track completion for each step
  const completed = steps.map((step, idx) => {
    if (idx === 0) return step.validate(values[step.key]);
    // Only complete if previous step is complete and this step is valid
    return steps[idx - 1].validate(values[steps[idx - 1].key]) && step.validate(values[step.key]);
  });

  // Handler for input changes
  const handleChange = (key) => (e) => {
    const value = e.target.type === "radio" ? e.target.value : e.target.value;
    setValues((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="page">
      <div style={{ maxWidth: 500, margin: "2rem auto" }}>
        {steps.map((step, idx) => {
          // Enable if all previous steps are complete
          const enabled = idx === 0 || completed[idx - 1];
          return (
            <div key={step.key} className="card" style={{ marginBottom: "1.5rem", padding: "1.5rem", opacity: enabled ? 1 : 0.5 }}>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              {step.render(values[step.key], handleChange(step.key), enabled)}
              {!enabled && <div style={{ color: '#888', fontSize: '0.9em', marginTop: '0.5em' }}>Complete previous step to enable</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
